
import { useState } from "react"
import { Copy, CheckCircle, Briefcase, Calendar, Mail, Phone } from "lucide-react"
import TasksSection from "./sections/tasks-section"

const ApprovedDashboard = ({ employee }) => {
  const [copied, setCopied] = useState(false)

  const promoCode = employee.promoCode || `Haz_Ref_${employee._id?.slice(-3).toUpperCase()}`

  const handleCopyPromoCode = () => {
    navigator.clipboard.writeText(promoCode)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="space-y-8">
      {/* Welcome Header */}
      <div className="mb-8 bg-gradient-to-r from-amber-400 via-amber-300 to-amber-200 dark:from-amber-900 dark:via-amber-800 dark:to-amber-700 rounded-lg p-8 shadow-md">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Welcome Back, {employee.fullName}</h1>
        <p className="text-gray-700 dark:text-gray-200 mt-2 font-medium">Hazer Global Employee Dashboard Portal</p>
        <div className="mt-4 flex flex-wrap gap-4 text-sm text-gray-700 dark:text-gray-300">
          <span className="flex items-center gap-1">
            <Mail className="w-4 h-4" /> {employee.email}
          </span>
          <span className="flex items-center gap-1">
            <Phone className="w-4 h-4" /> {employee.phoneNumber}
          </span>
        </div>
      </div>

      {/* Top Section: Promo Code (Right) and Tasks (Left) */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left: Tasks Section - Takes 2 columns */}
        <div className="lg:col-span-2">
          <TasksSection />
        </div>

        {/* Right: Promo Code Card */}
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-md border border-gray-200 dark:border-slate-700 p-6">
          <div className="flex items-center gap-2 mb-4">
            <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400" />
            <h3 className="font-semibold text-gray-900 dark:text-white">Dashboard Activated</h3>
          </div>

          {/* Promo Code Section */}
          <div className="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700">
            <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">
              Your Referral Code
            </p>
            <div className="flex items-center gap-2 bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3 border border-amber-200 dark:border-amber-700">
              <code className="flex-1 font-mono font-bold text-amber-900 dark:text-amber-100 text-lg">{promoCode}</code>
              <button
                onClick={handleCopyPromoCode}
                className="p-2 hover:bg-amber-100 dark:hover:bg-amber-800 rounded-md transition-colors"
                title="Copy promo code"
              >
                <Copy
                  className={`w-4 h-4 ${copied ? "text-green-600 dark:text-green-400" : "text-amber-600 dark:text-amber-400"
                    }`}
                />
              </button>
            </div>
            {copied && <p className="text-xs text-green-600 dark:text-green-400 mt-2">✓ Copied to clipboard</p>}
          </div>

          {/* Employee Info */}
          <div className="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700 space-y-4">
            <div className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-gray-400 dark:text-gray-500 mt-1 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">Email</p>
                <p className="font-medium text-gray-900 dark:text-white break-all">{employee.email}</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-gray-400 dark:text-gray-500 mt-1 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">Phone</p>
                <p className="font-medium text-gray-900 dark:text-white">{employee.phoneNumber}</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Briefcase className="w-4 h-4 text-gray-400 dark:text-gray-500 mt-1 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">District</p>
                <p className="font-medium text-gray-900 dark:text-white">{employee.district || "N/A"}</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Calendar className="w-4 h-4 text-gray-400 dark:text-gray-500 mt-1 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">Join Date</p>
                <p className="font-medium text-gray-900 dark:text-white">
                  {new Date(employee.createdAt).toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="col-span-1 lg:col-span-2">
        </div>
      </div>

    </div>
  )
}

export default ApprovedDashboard
